// src/API/rest.mailsend.ts

import { useMutation, useQuery } from "@tanstack/react-query";
import { useRestAPI } from "./axiosAPI";

export function useForecastMailCC() {
    const api = useRestAPI();

    // GET: Fetch current CC configuration
    const fetchMailCC = useQuery({
        queryKey: ["forecast-mail-cc"],
        queryFn: async () => {
            const response = await api.get<{
                id: number;
                alert_cc_users: Array<{ FM03_EmployeeID: number }>;
                intimation_cc_users: Array<{ FM03_EmployeeID: number }>;
            }>({
                url: `${process.env.REACT_APP_BACKEND_URL}/transactions/forecast-mail-cc/`,
                mode: "protected",
            });

            return response;
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
    });

    // PUT: Update CC users
    const sendMailCC = useMutation({
        mutationFn: async (payload: {
            alert_cc_users_ids: number[];
            intimation_cc_users_ids: number[];
        }) => {
            const response = await api.put<
                { success: boolean; message: string },
                {
                    alert_cc_users_ids: number[];
                    intimation_cc_users_ids: number[];
                }
            >({
                url: `${process.env.REACT_APP_BACKEND_URL}/transactions/forecast-mail-cc/`,
                mode: "protected",
                data: payload,
            });

            if (!response.success) {
                throw new Error(response.message || "Failed to update mail CC");
            }

            return response;
        },
        onSuccess: () => {
            // Invalidate and refetch the config after successful update
            fetchMailCC.refetch();
        },
    });

    return {
        // GET
        currentConfig: fetchMailCC.data,
        isLoadingConfig: fetchMailCC.isLoading,
        isErrorConfig: fetchMailCC.isError,
        errorConfig: fetchMailCC.error,

        // PUT
        sendMailCC: sendMailCC.mutateAsync,
        isSending: sendMailCC.isPending,
        isError: sendMailCC.isError,
        error: sendMailCC.error,
        isSuccess: sendMailCC.isSuccess,
        reset: sendMailCC.reset,
    };
}